import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AccionEliminar } from "@shared/enums/AccionEliminar";
import { SaldoCliente, SolicitudCreditoDTO } from "@shared/models/controlCredito/SaldoCliente";
import { ModalConfirmComponent } from "@shared/generic-modals/modal-confirm.component";
import { ErrorModel } from "@shared/models/ErrorModel";
import { ControlCreditoService } from "@controlCredito/control-credito.service";
import { AuthService } from "@authentication/auth.service";
import { MessageService } from "@shell/message.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DecimalPipe } from "@angular/common";
import { UsuarioDTO } from "@shared/models/notificaciones";
import { UsuarioService } from "@account/usuario.service";

@Component({
  selector: 'app-reporte-solicitante',
  templateUrl: './reporte-solicitante.component.html',
  styleUrl: './reporte-solicitante.component.scss'
})
export class ReporteSolicitanteComponent implements OnInit {
  @Input() cliente!: SaldoCliente;
  @Input() cargandoPendiente!: boolean[][];
  @Input() i!: number;
  @Input() saldosFiltrados!: SaldoCliente[];
  @Output() bloquearPendiente: EventEmitter<boolean>= new EventEmitter<boolean>();
  @Output() saldosFiltradosChange:  EventEmitter<SaldoCliente[]>= new EventEmitter<SaldoCliente[]>();

  accionEliminar = AccionEliminar;

  constructor(private controlCreditoService: ControlCreditoService, public authService: AuthService, private usuarioService: UsuarioService,
              private messageService: MessageService, private modalService: NgbModal, public decimalPipe: DecimalPipe){}

  ngOnInit() {
    this.bloquearPendiente.emit(false);
  }

  anularPendiente(i: number, fila: 0 | 1, solicitudesCredito: SolicitudCreditoDTO, enumAccionEliminar: AccionEliminar) {
    const modalRef = this.modalService.open(ModalConfirmComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.mensaje = '¿Desea eliminar la solicitud pendiente?';
    modalRef.componentInstance.titulo = 'Eliminar Pendiente';
    modalRef.componentInstance.textoSi = 'Aceptar';
    modalRef.componentInstance.textoNo = 'Cancelar';
    modalRef.result.then((result) => {
      if (result === 'Si'){
        this.controlCreditoService.setAnulando(true);
        const usuarioBody = this.obtenerUsuario();
        this.bloquearPendiente.emit(true);
        this.cargandoPendiente[i][fila] = true;
        this.controlCreditoService.eliminarSolicitud(solicitudesCredito.id, enumAccionEliminar, usuarioBody)
          .subscribe((res:SolicitudCreditoDTO) => {
            this.messageService.showSuccessMessage('Solicitud anulada correctamente.');
            this.bloquearPendiente.emit(false);
            this.controlCreditoService.setAnulando(false);
            this.cargandoPendiente[i][fila] = false;
            this.saldosFiltrados = this.saldosFiltrados
              .map(saldo => ({
                ...saldo,
                solicitudesCrediticias: saldo.solicitudesCrediticias?.filter(
                  solicitud => solicitud.id !== res.id
                )
              }))
              .filter(saldo => saldo.solicitudesCrediticias.length > 0); // Elimina saldos sin solicitudes crediticias
            this.saldosFiltradosChange.emit(this.saldosFiltrados);
          }, (err: ErrorModel) => {
            this.messageService.showErrorMessage('No pudo anularse la solicitud: ' + err.description);
            this.bloquearPendiente.emit(false);
            this.controlCreditoService.setAnulando(false);
            this.cargandoPendiente[i][fila] = false;
          })
      }
    }, () => {
      this.bloquearPendiente.emit(false);
      this.controlCreditoService.setAnulando(false);
      this.cargandoPendiente[i][fila] = false;
    });
  }

  obtenerUsuario() : UsuarioDTO {
    const usuario = {
      id: this.usuarioService.getIdUsuario(),
      nombresCompletos: this.usuarioService.getNombresCompletosUsuario(),
      dni: this.usuarioService.getDniUsuario(),
      userName: this.usuarioService.getUsernameByName(),
      email: this.usuarioService.getEmailUsuario()
    }
    return usuario;
  }

  get anulando() {
    return this.controlCreditoService.anulando();
  }
}
